<svelte:options customElement={{
  tag: 'image-text',
  shadow: 'none',
  props: {
    src: { reflect: true, type: 'String' },
    alt: { reflect: true, type: 'String' },
    ratio: { reflect: true, type: 'String' },
    reverse: { reflect: true, type: 'Boolean' },
    caption: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * image3/4：画像＋テキスト（左寄せ/右寄せ）
   * パーツライブラリ準拠の mod-column.__imgText / __imgTextReverse 構造
   * @prop {string} src - 画像URL
   * @prop {string} alt - 画像alt
   * @prop {string} ratio - 画像:テキスト比率 '1-2','1-3','2-3','1-4','3-4','1-5','4-5'
   * @prop {boolean} reverse - 右寄せ（テキスト→画像）
   * @prop {string} caption - キャプション
   */
  export let src = '';
  export let alt = '';
  export let ratio = '1-2';
  export let reverse = false;
  export let caption = '';

  const ratioMap = {
    '1-2': ['__column_1-2', '__column_1-2'],
    '1-3': ['__column_1-3', '__column_2-3'],
    '2-3': ['__column_2-3', '__column_1-3'],
    '1-4': ['__column_1-4', '__column_3-4'],
    '3-4': ['__column_3-4', '__column_1-4'],
    '1-5': ['__column_1-5', '__column_4-5'],
    '4-5': ['__column_4-5', '__column_1-5']
  };

  $: classes = ratioMap[ratio] || ratioMap['1-2'];
  $: wrapClass = reverse ? 'mod-column __imgText __imgTextReverse' : 'mod-column __imgText';
</script>

<div class={wrapClass}>
  <div class={classes[0]}>
    {#if caption}
      <figure>
        <img {src} {alt} />
        <figcaption>{caption}</figcaption>
      </figure>
    {:else}
      <img {src} {alt} />
    {/if}
  </div>
  <div class={classes[1]}>
    <slot></slot>
  </div>
</div>

<style>
  /* Shadow DOM内でグローバルCSSが適用されないため、必要なスタイルを直接定義 */
  .mod-column {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .mod-column.__imgText {
    gap: 64px;
    align-items: flex-start;
  }

  .mod-column.__imgTextReverse {
    gap: 64px;
    align-items: flex-start;
    flex-direction: row-reverse;
  }

  /* 分割比率カラム */
  .__column_1-2 { flex: 0 0 calc(50% - 32px); max-width: calc(50% - 32px); }
  .__column_1-3 { flex: 0 0 calc(33.333% - 42px); max-width: calc(33.333% - 42px); }
  .__column_2-3 { flex: 0 0 calc(66.666% - 22px); max-width: calc(66.666% - 22px); }
  .__column_1-4 { flex: 0 0 calc(25% - 48px); max-width: calc(25% - 48px); }
  .__column_3-4 { flex: 0 0 calc(75% - 16px); max-width: calc(75% - 16px); }
  .__column_1-5 { flex: 0 0 calc(20% - 64px); max-width: calc(20% - 64px); }
  .__column_4-5 { flex: 0 0 calc(80% - 8px); max-width: calc(80% - 8px); }

  img {
    display: block;
    width: 100%;
    height: auto;
  }

  figcaption {
    margin-top: 8px;
    font-size: 14px;
    color: #666;
  }

  @media (max-width: 767px) {
    .mod-column.__imgText,
    .mod-column.__imgTextReverse {
      flex-direction: column;
      gap: 20px;
    }

    .__column_1-2,
    .__column_1-3,
    .__column_2-3,
    .__column_1-4,
    .__column_3-4,
    .__column_1-5,
    .__column_4-5 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
</style>
